module.exports = __webpack_public_path__ + "static/img/mobile-pay-success.381e268.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile-pay-success.png
// module id = U/ua
// module chunks = 73